/**
 * Livewire showHtmlModal() reuses #livewire-error, replaces its content, then calls
 * showModal() again while that dialog is still open. The HTML spec throws
 * InvalidStateError for that second call. The dialog is already visible and already
 * holds the new error, so the second showModal() is skipped. Other dialogs are unchanged.
 * See TMAEX-4437.
 */

export function installLivewireErrorModalGuard() {
    if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') {
        return;
    }

    const nativeShowModal = HTMLDialogElement.prototype.showModal;

    HTMLDialogElement.prototype.showModal = function showLivewireErrorModal() {
        if (this.id === 'livewire-error' && this.open) {
            return;
        }

        return nativeShowModal.call(this);
    };
}
